<template>
    <v-dialog v-model="dialog"   fullscreen transition="dialog-bottom-transition">
        <v-card
                class="mx-auto"
                max-width="400"
        >

            <v-toolbar tabs fixed dark color="teal darken-1" class="absolute top pa-0 lighten-3">

                <template v-if="loading">
                    <v-progress-linear indeterminate :height="2" color="white" />
                </template>

                <template v-if="client">
                    <v-btn icon @click="hide">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-layout wrap>
                        <v-flex xs12>
                            <h3 class="title font-weight-light text-center grow">
                                Historial de {{client.first_name}} {{client.last_name || ''}}
                            </h3>
                        </v-flex>
                    </v-layout>
                    <v-avatar size="40">
                        <v-img :src="client.avatar || getFakeAvatar(client.gender)"></v-img>
                    </v-avatar>
                </template>

                <template v-slot:extension>
                    <v-tabs
                            v-model="tabs"
                            height="50"
                            icons-and-text
                            active-class="white--text"
                            centered
                            color="transparent"
                            slider-color="white"
                    >
                        <v-tab
                                :href="`#tab-1`"
                        >
                            Citas
                            <v-icon size="18" :color="tabs === 'tab-2' ? 'secondary' : 'white'">fa-clock</v-icon>
                        </v-tab>
                        <v-tab
                                :href="`#tab-2`"
                        >
                            Pagos
                            <v-icon size="18" :color="tabs === 'tab-1' ? 'secondary' : 'white'">fa-money-check</v-icon>
                        </v-tab>
                    </v-tabs>
                </template>

            </v-toolbar>

            <v-container fluid pa-0>
                <v-layout wrap>
                    <v-flex xs12 lg8 offset-lg2 xl6 offset-xl3>
                        <v-tabs-items v-model="tabs">
                            <v-tab-item
                                    :value="`tab-1`"
                            >
                                <client-appointments-history v-if="client"  :client-id="client.id" />
                            </v-tab-item>

                            <v-tab-item
                                    :value="`tab-2`"
                            >
                                <client-payments-history v-if="client" :client-id="client.id" />
                            </v-tab-item>

                        </v-tabs-items>
                    </v-flex>
                </v-layout>
            </v-container>

        </v-card>
    </v-dialog>
</template>

<script>
    import {getFakeAvatar} from '@/utils/Common'
    import {getCompanionLabel, getSubTypeLabel, getSubTypeIcon} from '@/utils/ScheduleEvent'
    import {ApiUtils} from '@/utils/ApiUtils'
    import {mapState, mapMutations} from 'vuex'
    import ClientAppointmentsHistory from "./ClientAppointmentsHistory";
    import ClientPaymentsHistory from "./ClientPaymentsHistory";

    export default{
        components: {ClientPaymentsHistory, ClientAppointmentsHistory },
        data(){
            return {
                tabs: 'tab-1',
                dialog: false,
                loading: false,
                history:[],
                client: null,
                total: 0
            }
        },
        methods: {
                ...mapMutations(['showSnackBar']),
            getFakeAvatar,
            showSummary(evtId){
                var vm = this
                const evt = vm.history.find(evt => evt.id === evtId)
                vm.$refs.attentionSummaryDialog.show(evt)
            },
            async show(clientId){
                var vm = this

                vm.client = null
                vm.history = []
                vm.dialog = true

                if(vm.loading || !vm.currentProvider) return
                vm.loading = true
                const response = await ApiUtils.makeGet(
                    `providers/${vm.currentProvider.id}/client/${clientId}/attention-history`
                )
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.showSnackBar(json.message || 'Ha ocurrido un error cargando el historial')
                    return
                }

                const json = await response.json()
                vm.history = json.result.attention_history.data
                vm.total = json.result.attention_history.total
                vm.client = json.result.client

            },
            hide(){
                this.dialog = false
            }
        },
        computed: {
            ...mapState(['currentProvider', 'dark']),
            ...mapState('clientAttention', {
                currentEvent: state => state.currentEvent
            }),
            blockClass(){
                const vm = this
                let baseClass = 'section py-1 pl-2'
                if(vm.dark){
                    baseClass += ' white--text secondary lighten-2'
                }else{
                    baseClass += ' black--text grey lighten-3'
                }
                return baseClass
            },
            baseColor(){
                const vm = this
                return vm.dark ? 'secondary' : 'grey lighten-3'
            },
            sessionColor(){
                const vm = this
                return vm.dark ? 'grey lighten-2' : 'secondary darken-1'
            },
            groups(){
                var vm = this
                if(vm.history.length === 0) return []
                const years = vm.history.map(evt => vm.$moment(evt.date, 'YYYY').format('YYYY'))
                const groups = [...new Set(years)]

                var all = {}

                for(let year in groups){
                    all[groups[year]] = vm.history
                        .filter(evt => {
                            return vm.$moment(evt.date, 'YYYY').format('YYYY') === groups[year]
                        }).map(event => {
                            var evt = JSON.parse(JSON.stringify(event))
                            evt.human_date_time = vm.$moment(evt.date).format('ddd') + ', ' +
                                    vm.$moment(evt.date).format('D') + ' ' +
                                    vm.$moment(evt.date).format('MMMM')
                            evt.time = vm.$moment( evt.time, 'HH:mm:ss').format('HH:mm') + ' hrs.'

                            if(!evt || !evt.anamnesis ||
                                    (
                                            evt.anamnesis && evt.anamnesis.symptoms.length === 0 &&
                                            evt.anamnesis.anamnesis_options.length === 0 &&
                                            !evt.anamnesis.comment
                                    )

                            ){
                                evt.anamnesis = null
                            }else{
                                var anamnesis = JSON.parse(JSON.stringify(evt.anamnesis))
                                anamnesis.symptoms = anamnesis.symptoms.map(symptom => {
                                    const eye = symptom.pivot.eye ? (
                                            symptom.pivot.eye === 'left' ? 'izquierdo' :
                                                    (symptom.pivot.eye === 'right' ? 'derecho' : 'ambos')
                                    ): null
                                    return {
                                        description: symptom.description,
                                        duration: symptom.pivot.duration,
                                        duration_unit: vm.durationUnits[symptom.pivot.duration_unit],
                                        eye: eye
                                    }
                                })

                                evt.anamnesis = anamnesis
                            }

                            if(evt.client_relationship){
                                evt.relationship = getCompanionLabel(evt.client_relationship)
                            }else{
                                evt.relationship = null
                            }

                            evt.sub_type_description = getSubTypeLabel(evt.sub_type)
                            evt.sub_type_icon = getSubTypeIcon(evt.sub_type)

                            if(evt.psychological_record){
                                evt.discharge = evt.psychological_record.last_session && evt.psychological_record.session_number !== 0
                                evt.session_name = evt.psychological_record.session_number === 0 ? 'Primera cita' :
                                        `Sesión ${evt.psychological_record.session_number}`
                                evt.session_color = evt.psychological_record.session_number === 0 ? 'secondary' : 'primary'
                            }

                            return evt
                        })
                }

                return all

            },
            durationUnits(){
                return {
                    'year': 'año(s)',
                    'month': 'mes(es)',
                    'week': 'semana(s)',
                    'day': 'día(s)',
                    'hour': 'hora(s)'
                }
            },
        }
    }
</script>

<style scoped>

    .indent{
        margin-left: 0
    }

    .total{
        font-family: Roboto, sans-serif;
        font-size: 3em;
        font-weight: 300;
    }
</style>
